import { OrganogramModel } from './OrganogramModel';
import { EditAction } from '../shared/enum/EditAction';
import { KeywordModel } from './KeywordModel';
import { VehicleModel } from './VehicleModel';

export interface CutoutModel {
    id: number,
    description: string,
    clientId: number,
    organograms: OrganogramModel[],
    keywords: KeywordModel[],
    vehicles: VehicleModel[],
    startOfPeriod: Date | null,
    endOfPeriod: Date | null,
    userId: number,
    councurrent: boolean,
    editAction: EditAction,
}

export const cutoutModelInitial: CutoutModel = {
    id: 0,
    description: '',
    clientId: 0,
    organograms: [],
    keywords: [],
    vehicles: [],
    startOfPeriod: null,
    endOfPeriod: null,
    userId: 0,
    councurrent: false,
    editAction: EditAction.NONE,
};